// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"354":"f6fcfc11","973":"090247ef"}[chunkId] + ".chunk.js";
};